import type { CSSProperties, ReactNode } from 'react';

export function Card({
  children,
  title,
  subtitle,
  actions,
  padded = true,
  style,
}: {
  children: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  padded?: boolean;
  style?: CSSProperties;
}) {
  return (
    <section
      style={{
        background: '#fff',
        border: '1px solid #e2e8f0',
        borderRadius: 12,
        padding: padded ? '1.25rem 1.5rem' : 0,
        marginBottom: '1rem',
        boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
        ...style,
      }}
    >
      {(title || actions) && (
        <header
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
            gap: '1rem',
            flexWrap: 'wrap',
            marginBottom: subtitle || children ? '0.75rem' : 0,
          }}
        >
          <div>
            {title && (
              <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: 600, color: '#0f172a' }}>
                {title}
              </h3>
            )}
            {subtitle && (
              <p style={{ margin: '0.15rem 0 0', color: '#64748b', fontSize: '0.85rem' }}>
                {subtitle}
              </p>
            )}
          </div>
          {actions && <div style={{ display: 'flex', gap: '0.5rem' }}>{actions}</div>}
        </header>
      )}
      {children}
    </section>
  );
}
